/**
 * Cabeçalho de página do admin: título, subtítulo e ações à direita. O `h1`
 * fixo do shell é só marca; cada página declara o seu `h2` aqui.
 */
import { createElement as h, type ReactElement, type ReactNode } from "react";

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps): ReactElement {
  return h(
    "header",
    { className: "flex flex-wrap items-end justify-between gap-3", "data-page-header": "true" },
    h(
      "div",
      { className: "min-w-0" },
      h("h2", { className: "text-2xl font-black text-ink sm:text-3xl" }, title),
      description ? h("p", { className: "mt-1 max-w-3xl text-base text-muted" }, description) : null
    ),
    actions ? h("div", { className: "flex flex-wrap items-center gap-2" }, actions) : null
  );
}
